const updateLimit_daily = {
  created: 1,
  published: 1,
  seeded: 2,
  activated: 3,
  launched: 5,
  retired: 1,
};

const updateLimit_weekly = {
  created: 5,
  published: 5,
  seeded: 7,
  activated: 10,
  launched: 15,
  retired: 5,
};

export {
  updateLimit_daily,
  updateLimit_weekly,
};
